import React from 'react';
import { useSelector } from 'react-redux';

import { AppState } from 'services/types';
import ListItem from 'components/ListItem';
import {
    FertilizerEntityId,
    FertilizerEntityIds
} from 'services/fertilizerEvents/types';
import { Grid } from 'semantic-ui-react';
import { makeSelectEntitiesGroupedByVariety } from './selectors';

export interface OwnProps {
    entityIds: FertilizerEntityIds;
    entityId: FertilizerEntityId;
}

type Props = OwnProps;

export default function SummaryBlocksListItem(
    props: Props
): React.ReactElement {
    const entitiesGroupedByVariety: Record<string, string> = useSelector(
        (state: AppState) => makeSelectEntitiesGroupedByVariety()(state, props)
    );

    return (
        <Grid.Row>
            {Object.keys(entitiesGroupedByVariety).map((variety) => (
                <Grid.Column mobile={8} tablet={4} computer={4} key={variety}>
                    <ListItem
                        description={variety}
                        value={entitiesGroupedByVariety[variety]}
                    />
                </Grid.Column>
            ))}
        </Grid.Row>
    );
}
